import {Button} from 'antd'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonGenerateCc(props) {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const {canAiGenerateCc, aiGenerateCc} = map.commands

    const nodes = canAiGenerateCc(selectedNodes)

    if (0 === nodes.length) {
        return null
    }

    const onClick = () => aiGenerateCc(nodes)

    return (
        <Button
            onClick={onClick}
            {...props}
        >
            AI程序能力定制分类
        </Button>
    )
}
